import type { MultiSelectOption } from '@/common/MultiSelectDropdown';
import { AppUserForDropdownDB, BuildLocationsForDropdownDB, OrderAccountsForDropdownDB, OrderStatusListDB } from '@/db/repositories';
import { TournamentDB } from '@/db/repositories/TournamentRepo';
import { ordersPresentation, OrdersPageType } from '@/components/Orders/Dashboard/OrdersPresentation';

export const clubSupplyOptions: MultiSelectOption[] = [
  { value: '1', label: 'Driver' },
  { value: '2', label: 'Fairway' },
  { value: '3', label: 'Hybrid' },
  { value: '4', label: 'Iron' },
  { value: '7', label: 'Utility' },
  { value: '5', label: 'Wedge' },
  { value: '30', label: 'Supply' },
];

const formatOrderStatus = (status: string) => status.replace('Order', '').trim();

export interface OrderFilterOptions {
  orderStatuses: MultiSelectOption[];
  buildLocations: MultiSelectOption[];
  orderAccounts: MultiSelectOption[];
  appUsers: MultiSelectOption[];
  headTypes: MultiSelectOption[];
  tournaments: MultiSelectOption[];
}

export const loadOrderFilterOptions = async (page: OrdersPageType, includeTournaments = true): Promise<OrderFilterOptions> => {
  const [statuses, locations, accounts, users, tournaments] = await Promise.all([
    OrderStatusListDB.list(),
    BuildLocationsForDropdownDB.list(),
    OrderAccountsForDropdownDB.list(),
    AppUserForDropdownDB.list(),
    !includeTournaments || page === OrdersPageType.Components ? Promise.resolve([]) : TournamentDB.list(),
  ]);
  const allowedStatuses = new Set(ordersPresentation[page].orderStatuses);
  const mapOptions = (records: { id: number; name: string; isActive?: boolean; sortId: number }[]) =>
    records
      .filter((record) => record.isActive)
      .sort((a, b) => a.sortId - b.sortId)
      .map((record) => ({ value: record.id.toString(), label: record.name }));
  return {
    orderStatuses: statuses
      .filter((record) => record.isActive)
      .sort((a, b) => a.sortId - b.sortId)
      .map((record) => ({ value: record.orderStatusId.toString(), label: formatOrderStatus(record.name) }))
      .filter((option) => allowedStatuses.has(option.label)),
    buildLocations: mapOptions(locations),
    orderAccounts: mapOptions(accounts),
    appUsers: mapOptions(users),
    headTypes: clubSupplyOptions,
    tournaments: tournaments
      .filter((record) => record.isActive)
      .sort((a, b) => a.sortId - b.sortId || a.name.localeCompare(b.name))
      .map((record) => ({ value: record.tournamentId.toString(), label: record.name })),
  };
};
